import * as React from 'react';

import { Field } from '@progress/kendo-react-form';

import {
    FormInput, FormAutoComplete, FormRadioGroup,
    FormTextArea
} from './form-components.jsx';

import {
    nameValidator, requiredValidator
} from './validators.jsx'

import {
    countries, genders
} from './data.jsx'

export const PersonalDetails = (
    <div>
        {/* <Field
            key={'fullName'}
            id={'fullName'}
            name={'fullName'}
            label={'Full Name'}
            component={FormInput}
            validator={nameValidator}
        />
        <Field
            key={'countryselected'}
            id={'countryselected'}
            name={'countryselected'}
            label={'Country'}
            hint={'Hint: Only Eroupean countries'}
            component={FormAutoComplete}
            data={countries}
            validator={requiredValidator}
        />
        <Field
            key={'gender'}
            id={'gender'}
            name={'gender'}
            label={'Gender'}
            layout={'horizontal'}
            component={FormRadioGroup}
            data={genders}
            validator={requiredValidator}
        /> */}
        <Field
            key={'execStatusSummary'}
            id={'execStatusSummary'}
            name={'execstatus_summary'}
            label={'Executive Status Summary'}
            validator={requiredValidator}
            component={FormTextArea}
        />
        <Field
            key={'keyAccomplishments'}
            id={'keyAccomplishments'}
            name={'key_accomplishments'}
            label={'Key Accomplishments in Past Week'}
            validator={requiredValidator}
            component={FormTextArea}
        />
        <Field
            key={'keyTasks'}
            id={'keyTasks'}
            name={'key_tasks'}
            label={'Key Tasks in Next 2 Weeks'}
            validator={requiredValidator}
            component={FormTextArea}
        />
    </div>
);